/** Tracks how long (seconds) an x position has stayed within `epsilon`. */
export class StuckAccumulator {
  private anchorX: number | null = null;
  private seconds = 0;
  constructor(private epsilon = 0.5) {}
  reset(): void { this.anchorX = null; this.seconds = 0; }
  update(x: number, dt: number): number {
    if (this.anchorX === null) {
      this.anchorX = x;
      this.seconds = Math.max(0, dt); // intentional: seed with first-frame dt so the caller sees elapsed time from frame 1, not 0
    } else if (Math.abs(x - this.anchorX) > this.epsilon) {
      this.anchorX = x;
      this.seconds = 0;
    } else {
      this.seconds += Math.max(0, dt);
    }
    return this.seconds;
  }
}
